import Palettes         from "../../../Domain/Palette/Store/Palettes";
import PalettesResource from "../../../Domain/Palette/PalettesResource";

export default class PalettesWatcher {

    interval;
    oldData;
    palettesStore;
    palettesResource;

    constructor() {
        this.interval = setInterval(() => this.watchForChanges(), 3000);
        this.palettesStore = new Palettes();
        this.palettesResource = new PalettesResource();
        this.setOldData(this.palettesStore.getPalettes());
    }

    watchForChanges() {
        let palettes = this.palettesStore.getPalettes();

        if(this.hasChanges(palettes)) {
            this.save(palettes);
        }

        this.setOldData(palettes);
    }

    setOldData(newData) {
        this.oldData = JSON.stringify(newData);
    }

    hasChanges(newData) {
        return this.oldData !== JSON.stringify(newData);
    }

    save(palettes) {
        this.palettesResource.commit({ palettes });
    }
}
